export default __webpack_public_path__ + "static/media/chronos-logo.2d7137cd.svg";